<template>
  <base-modal
    ref="modal"
    :title="isEditing ? 'Edit date' : 'Add key date'"
    @show="toggleModal"
    @hidden="resetModal"
    @ok="handleOk"
    ok-title="Save"
    cancel-title="Cancel"
    cancel-variant="light"
    footer-class="modal-footer-custom"
    header-class="modal-header-custom"
    body-class="modal-body-custom"
    content-class="modal-content-custom"
  >
    <form ref="form" @submit.stop.prevent="handleSubmit">
      <div>
        <div class="mb-4"><label for="deadlineLabel" class="block text-[13px] font-medium text-ink mb-1.5">Label</label>
          <select
            id="deadlineLabel"
            v-model="deadline.label"
            class="w-full appearance-auto border border-border-hover rounded-[10px] px-3.5 py-2.5 text-sm font-[inherit] leading-normal transition-[border-color] duration-150 focus:border-primary focus:ring-3 focus:ring-primary/10 outline-none"
          ><option v-for="opt in labelOptions" :key="opt.value !== undefined ? opt.value : opt" :value="opt.value !== undefined ? opt.value : opt">{{ opt.text !== undefined ? opt.text : opt }}</option></select>
        </div>

        <div v-if="deadline.label === 'Custom'" class="mb-4"><label for="customLabel" class="block text-[13px] font-medium text-ink mb-1.5">Custom label</label>
          <input
            id="customLabel"
            v-model="deadline.customLabel"
            required
            placeholder="e.g. Home Office response expected"
            class="w-full border border-border-hover rounded-[10px] px-3.5 py-2.5 text-sm font-[inherit] leading-normal transition-[border-color] duration-150 focus:border-primary focus:ring-3 focus:ring-primary/10 outline-none"
          >
        </div>

        <div class="mb-4"><label for="deadlineDate" class="block text-[13px] font-medium text-ink mb-1.5">Date</label>
          <date-input
            v-model="deadline.date"
            placeholder="Select date"
            :required="true"
          ></date-input>
        </div>

        <div class="mb-4"><label for="deadlineNote" class="block text-[13px] font-medium text-ink mb-1.5">Note (optional)</label>
          <input
            id="deadlineNote"
            v-model="deadline.note"
            placeholder="Additional details..."
            class="w-full border border-border-hover rounded-[10px] px-3.5 py-2.5 text-sm font-[inherit] leading-normal transition-[border-color] duration-150 focus:border-primary focus:ring-3 focus:ring-primary/10 outline-none"
          >
        </div>
      </div>
    </form>
  </base-modal>
</template>

<script>
import DateInput from '../../UIComponents/DateInput'

export default {
  name: 'deadline-add-modal',
  components: { DateInput },
  props: {
    item: {
      type: Object,
      default: null
    },
    editIndex: {
      type: Number,
      default: -1
    }
  },
  data () {
    return {
      deadline: {
        label: 'Endorsement submission',
        customLabel: '',
        date: '',
        note: '',
        completed: false
      },
      labelOptions: [
        'Endorsement submission',
        'Endorsement decision',
        'Visa application',
        'Visa decision',
        'Endorsement expiry',
        'Documents due',
        'Payment due',
        'Client meeting',
        'Custom'
      ]
    }
  },
  computed: {
    isEditing () {
      return this.item !== null && this.editIndex >= 0
    }
  },
  methods: {
    handleSubmit () {
      if (this.deadline.label === 'Custom' && !this.deadline.customLabel.trim()) {
        return
      }
      if (!this.deadline.date) {
        return
      }
      const label = this.deadline.label === 'Custom' && this.deadline.customLabel
        ? this.deadline.customLabel.trim()
        : this.deadline.label

      const data = {
        label: label,
        date: this.deadline.date,
        note: this.deadline.note,
        completed: this.deadline.completed || false
      }

      this.$emit('save', {
        deadline: data,
        index: this.isEditing ? this.editIndex : -1
      })

      this.$nextTick(() => {
        this.$refs.modal.hide()
      })
    },
    resetModal () {
      this.deadline.label = 'Endorsement submission'
      this.deadline.customLabel = ''
      this.deadline.date = ''
      this.deadline.note = ''
      this.deadline.completed = false
    },
    toggleModal () {
      this.resetModal()
      if (this.item) {
        const matchesPreset = this.labelOptions.includes(this.item.label)
        this.deadline.label = matchesPreset ? this.item.label : 'Custom'
        this.deadline.customLabel = matchesPreset ? '' : this.item.label
        this.deadline.date = this.item.date || ''
        this.deadline.note = this.item.note || ''
        this.deadline.completed = this.item.completed || false
      }
    },
    showModal () {
      this.$refs.modal.show()
    },
    hideModal () {
      this.$refs.modal.hide()
    },
    handleOk (bvModalEvt) {
      bvModalEvt.preventDefault()
      this.handleSubmit()
    }
  }
}
</script>
